import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { CreateChancel, InputMain } from 'components';
import { FindErrorItem, FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, systemActions } from 'store';

const ACTION_TYPE = 'STRIPE_SETTINGS';
export const ConnectStripe = () => {
    const { close } = useModal();
    const { handleSubmit, control, setError, clearErrors } = useForm();
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        clearErrors();
    }, []);

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
        if (backError?.error === 'Invalid API Key provided') {
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
            setError('secretKey', {
                type: 'required',
                message: backError?.error,
            });
        }
    }, [success, backError]);
    const handleCreate = (data) => {
        dispatch(
            systemActions.stripeSettings({
                settingsType: 'stripe',
                isActive: true,
                publishableKey: data.publishableKey,
                secretKey: data.secretKey,
            })
        );
    };

    return (
        <div style={{ width: 400 }}>
            <div className="office-ally-header">
                <div className="office-ally-header-icons">
                    <div>
                        <img src={Images.logoSmall} alt="" />
                    </div>
                    <img src={Images.compareArrows} alt="arrow" />
                    <div>
                        <img src={Images.stripe} alt="" />
                    </div>
                </div>
                <p>Connect to Stripe</p>
            </div>
            <form onSubmit={handleSubmit(handleCreate)}>
                <InputMain
                    label={'Publishable Key (PK)*'}
                    customClass={true}
                    variant="outlined"
                    name="publishableKey"
                    type="text"
                    control={control}
                    placeholder="Enter your Stripe Publishable Key"
                    rules={{
                        required: 'Publishable Key is required.',
                    }}
                />
                <InputMain
                    label={'Secret Key (SK)*'}
                    customClass={true}
                    variant="outlined"
                    name="secretKey"
                    type="text"
                    showPassword={showPassword}
                    control={control}
                    placeholder="Enter your Stripe Secret Key"
                    rules={{
                        required: 'Secret Key is required.',
                    }}
                    onClickIconEnd={() => setShowPassword((prev) => !prev)}
                />
                <div style={{ marginTop: 12 }}>
                    <CreateChancel
                        type="submit"
                        loader={!!loader.length}
                        create={'Connect'}
                        chancel={'Cancel'}
                        onClose={close}
                        buttonWidth={'100%'}
                    />
                </div>
            </form>
        </div>
    );
};
